import { useCallback, useLayoutEffect, useRef, useState } from 'react';

export function useScaledMenuProps<T extends Record<string, any>>(
  menuProps: T | undefined,
  open?: boolean
) {
  const anchorRef = useRef<HTMLDivElement>(null);
  const [menuWidth, setMenuWidth] = useState<number>();

  const measure = useCallback(() => {
    if (anchorRef.current) {
      setMenuWidth(anchorRef.current.getBoundingClientRect().width);
    }
  }, []);

  useLayoutEffect(() => {
    if (open) measure();
  }, [open, measure]);

  const paper = menuProps?.slotProps?.paper;
  if (!menuWidth || typeof paper === 'function') {
    return { anchorRef, measure, menuProps };
  }

  return {
    anchorRef,
    measure,
    menuProps: {
      ...menuProps,
      slotProps: {
        ...menuProps?.slotProps,
        paper: {
          ...paper,
          style: { ...paper?.style, minWidth: menuWidth },
        },
      },
    } as unknown as T,
  };
}
